export function IsEmptyObject(objectToCheck: object) {
  try {
    return JSON.stringify(objectToCheck) === '{}';
  } catch {
    // Prevent TypeError: Converting circular structure to JSON
    return objectToCheck === undefined || objectToCheck === null;
  }
}
